import { useMemo } from 'react';
import type { SessionSummary } from '@/api/types';

export type DisplayStatus = 'starting' | 'on' | 'running' | 'stopping' | 'off';

export const useAgentStatus = (
  activeChatId: string | null,
  isRunning: boolean | undefined,
  sessions: SessionSummary[],
) => {
  const runningCount = useMemo(
    () => sessions.reduce((acc, s) => acc + (s.runtime_status === 'on' ? 1 : 0), 0),
    [sessions],
  );

  const activeSessionForChat = useMemo(
    () => activeChatId ? sessions.find((s) => s.id === activeChatId) : undefined,
    [activeChatId, sessions],
  );

  const hasActiveRun = !!activeSessionForChat?.active_run_id;

  const activeAgentStatus = useMemo((): DisplayStatus | undefined => {
    if (!activeChatId) return undefined;
    const session = activeSessionForChat;
    if (!session) return undefined;
    if (session.runtime_status === 'on') {
      return (isRunning || session.active_run_id) ? 'running' : 'on';
    }
    return session.runtime_status;
  }, [activeChatId, isRunning, activeSessionForChat]);

  return { runningCount, activeSessionForChat, hasActiveRun, activeAgentStatus };
};
